import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export const chartsToolbarClasses = generateUtilityClasses('MuiChartsToolbar', ['root']);